<template>
  <div>
    <vxe-modal
        v-model="isShow"
        width="1200"
        height="600"
        resize
        remember
        title="创建"
    >
      <div class="add-box clearfix">
        <table-header @add="insertEvent" @remove="removeEvent" @copy="copyEvent"></table-header>
        <vxe-table
            border
            show-overflow
            keep-source
            class="table-style"
            ref="xTable"
            highlight-hover-row
            max-height="440"
            :data="tableData"
            :edit-rules="editRules"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'cell' }"
            @scroll="$refs.xTable.clearValidate()"
        >
          <vxe-table-column align="center" type="checkbox" width="40"></vxe-table-column>
          <vxe-table-column
              type="seq"
              width="60"
              align="center"
              title="序号"
          ></vxe-table-column>
          <vxe-table-column field="replaceTaxpayer" title="纳税人名称">
            <template v-slot:header="{ column }">
            <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <div class="link-text" @click="openChoosePerson(row, 'replaceTaxpayer')">
                {{ row.replaceTaxpayer ? row.replaceTaxpayer : "请选择" }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="repalceTaxNum" title="纳税人号码">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.repalceTaxNum" placeholder="选填" maxlength="200"
                         @input='$refs.xTable.clearValidate("repalceTaxNum")'></vxe-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="year" title="纳税年度">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.year" placeholder="必填" type="year" align="center" maxlength="16"
                         @input='$refs.xTable.clearValidate("year")'></vxe-input>
            </template>
          </vxe-table-column>

          <vxe-table-column field="initBalance" title="年度期初余额">
            <template v-slot:header="{ column }">
              <span class="column-title"> <i style="color: #f00"> * </i>{{ column.title }}</span>
            </template>
            <template v-slot="{ row }">
              <vxe-input v-model="row.initBalance" placeholder="必填" type="number" maxlength="16"
                         @input='$refs.xTable.clearValidate("initBalance")'></vxe-input>
            </template>
          </vxe-table-column>
        </vxe-table>
        <div class="footer-wrap">
          <Button type="primary" @click="submitEvent('new')">提 交</Button>
        </div>
      </div>
    </vxe-modal>

    <vxe-modal
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择客户"
    >
      <account @choose="chooseAccountEvent" ref="chooseAccount"></account>
    </vxe-modal>
  </div>
</template>

<script>
import {
  assign,
  hideLoading,
  isEmpty,
  isNotEmpty,
  showError,
  showFailMsgList,
  showLoading,
  showSuccess, sleep
} from "@/utils/util";
import {apiPost} from "@/utils/api";
import TableHeader from "@/components/common/TableHeader";
import Account from "@/components/modal/InvoiceAccount";

export default {
  name: "AddBuyerYearInvoice",
  components: {TableHeader, Account},
  data() {
    return {
      isShow: false,
      isShowChooseAccount: false,
      tableData: [],
      dataTmp: {
        replaceTaxpayer: "",
        repalceTaxNum: "",
        taxpayerId: "",
        initBalance: "",
        year: ""
      },
      yearList: [],
      editRules: {
        repalceTaxNum: [
          {
            validator: this.requireValid,
          },
        ],
        replaceTaxpayer: [
          {
            validator: this.requireValid,
          },
        ],
        year: [
          {
            validator: this.requireValid,
          },
        ],
        initBalance: [
          {
            validator: this.requireValid,
          },
        ],
      },
    }
  },
  mounted() {
  },
  methods: {
    async requireValid(e) {
      if (isEmpty(e.cellValue)) {
        return Promise.reject(new Error(e.column.title + '必填'))
      }
    },
    async show() {
      this.isShow = true
      this.tableData = [assign(this.dataTmp)];
      this.$refs.xTable.getTableData().tableData = this.tableData
      this.insertEvent()
    },
    openChoosePerson(row) {
      this.isShowChooseAccount = true;
      this.currentRow = row;
      this.$refs.chooseAccount.initAccount(1, 1);
    },
    chooseAccountEvent(account, type) {
      console.log("chooseAccountEvent", account);
      this.currentRow['taxpayerId'] = account.id;
      this.currentRow['replaceTaxpayer'] = account.userName;
      this.currentRow['repalceTaxNum'] = account.idcardNum;
      this.currentRow['canEditIdCarNum'] = false;
      this.$refs.xTable.clearValidate("replaceTaxpayer");
      this.$refs.xTable.clearValidate("repalceTaxNum");
      this.isShowChooseAccount = false;
    },
    insertEvent() {
      let tableData = this.$refs.xTable.getTableData().tableData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
          this.$XModal.message({
            message: "不能全部删除,至少保留一条",
          });
          return;
        }
      }
      let confirmRes = await this.$XModal.confirm("删除后不可恢复", "是否删除？");
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择",
        });
        return;
      }
      this.$refs.xTable.insertAt(checkboxRecords, -1);
    },
    async validEvent() {
      const errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    async submitEvent() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！"
        });
        return
      }
      let param = []
      this.tableData = this.$refs.xTable.getTableData().tableData
      this.tableData.forEach(item => {
        param.push({
          replaceTaxpayer: item.replaceTaxpayer,
          repalceTaxNum: item.repalceTaxNum,
          taxpayerId: item.taxpayerId,
          initBalance: item.initBalance,
          year: item.year.substring(0, 4)
        })
      })
      showLoading()
      let res = await apiPost("api/order/", "twoReport/creatInitBalance", param);
      hideLoading()
      if (res.status == 1) {
        showSuccess("设置成功")
        await sleep(1000)
        this.isShow = false;
        this.$emit("success")
      } else if (res.message) {
        showError(res.message)
      } else if (isNotEmpty(res.data)) {
        showFailMsgList(res.data)
      } else {
        showError("服务端错误")
      }

    },
  }
}
</script>

<style scoped>

</style>